<template>
    <span v-if="currentUser.primary_calendar_id"
          class="flex items-center"
    >
        <span class="shrink-0">
            <svg-icon v-if="sync" class="max-w-16 max-h-16 text-secondary-80" type="check-circle"></svg-icon>
            <svg-icon v-else class="max-w-16 max-h-16 text-semantic-warning" type="warning"></svg-icon>
        </span>
        <span class="ml-8 text-body-sm text-primary-80">
            <template v-if="sync">
                {{ $t('calendar.auto_sync') }}
            </template>
            <template v-else>
                {{ $t('calendar.no_auto_sync') }}
            </template>
        </span>
    </span>
</template>

<script>
import SvgIcon from './SvgIcon.vue';
import {mapState} from 'pinia';
import {useAuthenticationStore} from '../../state/modules/authentication';

export default {
    components: {SvgIcon},
    props: {
        sync: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
       ...mapState(useAuthenticationStore, ['currentUser'])
    },
};
</script>
